import en from './en.json';
import uk from './uk.json';
import pl from './pl.json';
import ru from './ru.json';
import es from './es.json';
import uz from './uz.json';
import hi from './hi.json';
import { createLocale } from '../../utils.js';

const locales = {
  en: createLocale(en, 'profile'),
  uk: createLocale(uk, 'profile'),
  pl: createLocale(pl, 'profile'),
  ru: createLocale(ru, 'profile'),
  es: createLocale(es, 'profile'),
  uz: createLocale(uz, 'profile'),
  hi: createLocale(hi, 'profile'),
};

export default locales;
